import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/dist/css/splide.min.css'

document.querySelectorAll(".element-photogalleryslider").forEach((el) => {

  const container = el.querySelector(".splide");
  const numSlides = el.querySelectorAll(".splide__slide").length;
  if (!container) {
    const autoplaySlider = container && container.dataset.auto-play === 'true';

    if (numSlides < 2) {
      return;
    }

    if (autoplaySlider) {
      const splide = new Splide(container, {
        perPage: 'auto',
        perMove: 1,
        type: 'loop',
        pagination: false,
        arrows: false,
        autoWidth: true,
        gap: 40,
        autoScroll: {
          speed: .5,
          pauseOnHover: true,
          pauseOnFocus: true,
        },
        breakpoints: {
          768: {
            gap: 20,
          },
        }
      }).mount({ AutoScroll });
    } else {
      new Splide(container, {
        perPage: 1,
        perMove: 1,
        type: 'loop',
        pagination: false,
        arrows: true,
      }).mount();
    }

  }

})
